<template>
<div>
  <div class="flex flex-wrap mt-4">
    <div class="w-full lg:w-1/3">
      <div class>
        <h3 class="text-lg font-medium leading-6 text-gray-900">Settings</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">Configure and define</p>
      </div>
    </div>

    <div class="w-full lg:w-2/3 mb-12">
      <div class="shadow overflow-hidden sm:rounded-md p-4 bg-gray-200">
        <div class="flex flex-wrap">
          <div class="w-32 mr-4 mb-4 lg:mb-0">
            <label
              class="block text-sm font-medium leading-5 text-gray-700 truncate"
            >Currency symbol</label>
            <select
              v-model="settings.currency"
              class="form-select w-full truncate rounded bg-white border border-gray-400"
            >
              <option selected>£</option>
              <option>$</option>
              <option>€</option>
            </select>
          </div>
        </div>
      </div>
    </div>

<!-- HIDDEN
    <div class="w-full lg:w-1/3">
      <div class>
        <h3 class="text-lg font-medium leading-6 text-gray-900">Time</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">Units of measure for time</p>
      </div>
    </div>

    <div class="w-full lg:w-2/3">
      <div class="shadow overflow-hidden sm:rounded-md p-4 bg-gray-200 mb-4">
        <div class="block text-sm font-medium leading-5 text-gray-700 mb-2">Units of time in use</div>
        <div class="flex flex-wrap">
          <div class="mr-8 mb-2">
            <div class="relative flex items-start">
              <div class="absolute flex items-center h-5">
                <input
                  id="seconds"
                  model="settings.time.unitoftimeseconds"
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-gray-600"
                />
              </div>
              <div class="pl-6 leading-5">
                <label for="seconds" class>Seconds</label>
              </div>
            </div>
          </div>
          <div class="mr-8 mb-2">
            <div class="relative flex items-start">
              <div class="absolute flex items-center h-5">
                <input
                  id="minutes"
                  model="settings.time.unitoftimeminutes"
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-gray-600"
                />
              </div>
              <div class="pl-6 leading-5">
                <label for="minutes" class>Minutes</label>
              </div>
            </div>
          </div>
          <div class="mr-8 mb-2">
            <div class="relative flex items-start">
              <div class="absolute flex items-center h-5">
                <input
                  id="hours"
                  model="settings.time.unitoftimehours"
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-gray-600"
                />
              </div>
              <div class="pl-6 leading-5">
                <label for="hours" class>Hours</label>
              </div>
            </div>
          </div>
          <div class="mr-8 mb-2">
            <div class="relative flex items-start">
              <div class="absolute flex items-center h-5">
                <input
                  id="days"
                  :model="settings.time.unitoftimedays"
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-gray-600"
                />
              </div>
              <div class="pl-6 leading-5">
                <label for="days" class>Days</label>
              </div>
            </div>
          </div>
          <div class="mr-8 mb-2">
            <div class="relative flex items-start">
              <div class="absolute flex items-center h-5">
                <input
                  id="weeks"
                  :model="settings.time.unitoftimeweeks"
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-gray-600"
                />
              </div>
              <div class="pl-6 leading-5">
                <label for="weeks" class>Weeks</label>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full border-b-2 py-2 mb-4"></div>

        <div class="flex">
          <div class="mr-4">
            <label
              class="block text-sm font-medium leading-5 text-gray-700 truncate"
            >Base unit of time</label>
            <select
              v-model="settings.time.baseunitoftime"
              class="form-select w-full truncate"
            >
              <option>Seconds</option>
              <option>Minutes</option>
              <option selected>Hours</option>
              <option>Days</option>
              <option>Weeks</option>
            </select>
          </div>
          <div class="mr-4">
            <label class="block text-sm font-medium leading-5 text-gray-700 truncate">Hours per day</label>
            <input
              type="number"
              placeholder="8"
              v-model="settings.time.hoursperday"
              class="w-24 form-input text-right"
            />
          </div>
          <div class="mr-4">
            <label class="block text-sm font-medium leading-5 text-gray-700 truncate">Hours per week</label>
            <input
              type="number"
              placeholder="40"
              v-model="settings.time.hoursperweek"
              class="w-24 form-input text-right"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-1/3">
      <div class>
        <h3 class="text-lg font-medium leading-6 text-gray-900">Items</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">Defaults for new cost items</p>
      </div>
    </div>

    <div class="w-full lg:w-2/3">
      <div class="shadow overflow-hidden sm:rounded-md p-4 bg-gray-200 mb-4">
        <div class="flex">
          <div class="mr-4">
            <label
              class="block text-sm font-medium leading-5 text-gray-700 truncate"
            >Unit of measure</label>
            <select
              class="form-select w-full truncate rounded bg-white border border-gray-400"
            >
              <option>Materials</option>
              <option>Seconds</option>
              <option>Minutes</option>
              <option>Hours</option>
              <option>Days</option>
              <option>Weeks</option>
            </select>
          </div>
          <div class="mr-4">
            <label
              class="block text-sm font-medium leading-5 text-gray-700 truncate"
            >Quantity</label>
            <input
              type="number" placeholder="1" model=""
              class="w-24 form-input text-right bg-white rounded border border-gray-400"
            />
          </div>
        </div>
      </div>
    </div>
-->
    <div class="w-full lg:w-1/3">
      <div class>
        <h3 class="text-lg font-medium leading-6 text-gray-900">Default values</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">Tax, markup, etc.</p>
      </div>
    </div>

    <div class="w-full lg:w-2/3">
      <div class="shadow overflow-hidden sm:rounded-md p-4 bg-gray-200 mb-4">

        <div class="w-full border-b mb-2">
          <p>Default values that are set when new prices are created.</p>
        </div>

        <div class="flex flex-wrap gap-4">
          <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700 truncate">Tax rate</label>
            <input
              type="number"
              placeholder="20"
              v-model="settings.tax.rate"
              class="w-24 p-1 pr-6 align-middle text-right bg-white rounded border border-gray-400"
            />
            <span class="absolute right-0 pr-1 mt-1 text-gray-500">%</span>
          </div>
          <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700 truncate">
              Markup
              <div class="absolute top-0 right-0 -mt-1 text-gray-400 hover:text-gray-black cursor-pointer" title="% to add on top of costs">
                <div class="w-4 h-4"><IconInfo></IconInfo></div>
              </div>
            </label>
            <input
              type="number"
              placeholder="25"
              v-model="settings.markup.rate"
              class="w-24 p-1 pr-6 align-middle text-right bg-white rounded border border-gray-400"
            />
            <span class="absolute right-0 pr-1 mt-1 text-gray-500">%</span>
          </div>
        </div>

      </div>
    </div>

    <div class="w-full lg:w-1/3">
      <div class>
        <h3 class="text-lg font-medium leading-6 text-gray-900">Meta</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">Be careful!</p>
      </div>
    </div>

    <div v-if="settings.debug" class="w-full lg:w-2/3">
      <div class="shadow overflow-hidden sm:rounded-md p-4 bg-gray-200 mb-4">
        <div class="block text-sm font-medium leading-5 text-gray-700 mb-2">Debug</div>
        <div class="flex justify-between">
          <div class="flex mb-4">
            <input
              id="showJsonModels"
              v-model="showJsonModels"
              type="checkbox"
              class="form-checkbox h-4 w-4 text-gray-600 mr-4"
            />
            <label class="leading-none" for="showJsonModels">Show JSON models</label>
          </div>
          <div class="">
            <button class="btn" @click="clearStorage">Clear storage</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
</template>

<script>
import IconInfo from '../components/icons/IconInfo';

export default {
  name: 'Settings',
  components: {
    IconInfo
  },
  computed: {
    showJsonModels: {
      get() {
        return this.$store.state.settings.settings.debug.showJsonModels;
      },
      set(value) {
        this.$store.dispatch('settings/updateDebug', value);
      }
    },
    settings: {
      get() {
        return this.$store.state.settings.settings;
      },
      set(value) {
        console.log(value)
        this.$store.commit('UPDATE_SETTINGS', value);
      },
    }
  },
  methods: {
    saveSettings(){
      //this.$store.dispatch('settings/updateSettings', this.settings)
    },
    clearStorage(){
      if(window.confirm('Are you sure? \n \nThis will delete all prices and revert to the sample prices.')){
        window.localStorage.removeItem('prices')
        location.replace('/')
      }
    }
  },
  mounted() {
  }
};
</script>
